import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {WebService} from "../services/web/web.service";
import {SecurityService} from "../services/security.service";

@Injectable()
export class Logging implements HttpInterceptor {

    constructor(private http: HttpClient, private webService: WebService, private securityService: SecurityService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


        const serviceUrl = req.urlWithParams; // URL del servicio que está siendo invocado
        // Omitir las solicitudes al endpoint /log para evitar el loop infinito
        // Omitir servicios GET
        // Omitir rutas de autenticación y refresh para no loguear datos sensibles
        if (req.headers.has('X-Skip-Interceptor') || serviceUrl.includes('/log') || req.method.includes("GET") || this.isAuthRoute(serviceUrl)) {
            return next.handle(req); // No hacer nada y continuar con la solicitud
        }

        const requestBody = req.body; // Cuerpo del request (si tiene)

        // Determinar el userId según el rol del usuario:
        // Si es admin (ROLE_onboarding_user_admin), usar userAdminId del JWT
        // De lo contrario, usar el header "user" de la petición (comportamiento original)
        const userId = this.resolveUserId(req);

        // Crear el payload para enviar al backend
        const logData = {
            userId: userId,
            serviceUrl: serviceUrl,
            requestBody: requestBody,
            method: req.method,
            type : "ONBOARDING"
        };

        // Enviar la información al servicio de logging en el backend
        this.http.post(this.webService.HOST + '/log', logData).subscribe({
            // next: () => console.log('Log guardado exitosamente.'),
            // error: err => console.error('Error guardando log:', err)
        });

        // Continuar con la solicitud original
        return next.handle(req);

    }

    /**
     * Determina el userId para el log según el rol del usuario.
     * Si el usuario tiene el permiso ROLE_onboarding_user_admin, se usa el campo
     * "userAdminId" del payload del JWT. De lo contrario, se usa el header "user"
     * de la petición (comportamiento asignado por AuthInterceptor).
     */
    private resolveUserId(req: HttpRequest<any>): string | null {
        try {
            if (this.securityService.isOnboardingAdmin()) {
                const decodedToken = this.securityService.getDecodedToken();
                if (decodedToken?.payload?.userAdminId) {
                    return decodedToken.payload.userAdminId.toString();
                }
            }
        } catch (e) {
            // Si falla la decodificación del token, usar el fallback del header
        }

        // AuthInterceptor se ejecuta después de Logging; usar memoria si el header aún no existe.
        const requestUser = req.headers.get("user");
        if (requestUser !== null) {
            return requestUser;
        }
        const tokenUser = this.securityService.getTokenUser();
        return tokenUser !== null && tokenUser !== undefined ? tokenUser.toString() : null;
    }

    /**
     * Verifica si la URL corresponde a una ruta de autenticación o refresh
     * Estas rutas se excluyen del logging para evitar registrar datos sensibles
     * (credenciales, tokens, etc.)
     */
    private isAuthRoute(url: string): boolean {
        const authRoutes = [
            '/auth/',        // Cubre: /auth/login, /auth/refresh, /auth/register, /auth/token
            '/oauth/',       // Cubre: /oauth/token y otros endpoints OAuth
            '/login',        // Endpoint de login directo
            '/resend-pin',   // Reenvío de PIN (contiene datos sensibles)
            '/validate-pin', // Validación de PIN
            '/resetPassword' // Recuperación de contraseña
        ];

        return authRoutes.some(route => url.includes(route));
    }
}
